import { NavLink, useNavigate } from "react-router-dom";
import { LayoutDashboard, Users, Building2, Briefcase, GitBranch, CheckSquare, Shield, LogOut, Calendar as CalendarIcon, ScrollText, ScanLine, IdCard, Share2, ClipboardCheck, BrainCircuit, ListChecks } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const NAV = [
    { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, testid: "sidebar-nav-dashboard", perm: "dashboard" },
    { to: "/leads", label: "Contactos", icon: Users, testid: "sidebar-nav-leads", perm: "contacts_view" },
    { to: "/companies", label: "Empresas", icon: Building2, testid: "sidebar-nav-companies", perm: "companies_view" },
    { to: "/deals", label: "Deals", icon: Briefcase, testid: "sidebar-nav-deals", perm: "deals_view" },
    { to: "/funnels", label: "Embudos", icon: GitBranch, testid: "sidebar-nav-funnels", perm: "funnels_view" },
    { to: "/tasks", label: "Tareas", icon: CheckSquare, testid: "sidebar-nav-tasks", perm: "tasks_view" },
    { to: "/calendar", label: "Calendario", icon: CalendarIcon, testid: "sidebar-nav-calendar", perm: "calendar_view" },
    { to: "/service-audit", label: "Auditoría de servicios", icon: ClipboardCheck, testid: "sidebar-nav-service-audit", permAny: ["service_financial_view", "service_weekly_audit_view", "service_backups_view", "code_security_view"] },
    { to: "/weekly-control", label: "Tráfico semanal", icon: ListChecks, testid: "sidebar-nav-weekly-control", perm: "weekly_control_view" },
    { to: "/ai-usage", label: "Consumo IA", icon: BrainCircuit, testid: "sidebar-nav-ai-usage", perm: "ai_usage" },
    { to: "/scan-card", label: "Escanear tarjeta", icon: ScanLine, testid: "sidebar-nav-scan", perm: "contacts_manage" },
    { to: "/my-card", label: "Mi tarjeta digital", icon: IdCard, testid: "sidebar-nav-mycard", perm: "dashboard" },
    { to: "/share-card", label: "Compartir mi tarjeta", icon: Share2, testid: "sidebar-nav-share", perm: "dashboard" },
];

const linkClass = ({ isActive }) => `flex items-center gap-3 px-3 py-2 rounded-md text-sm transition-colors ${isActive ? "bg-orange-500 text-white font-medium" : "text-slate-300 hover:bg-slate-800 hover:text-white"}`;

export default function Sidebar() {
    const { user, logout, hasPermission, hasAnyPermission } = useAuth();
    const navigate = useNavigate();
    const visibleNav = NAV.filter((item) => item.permAny ? hasAnyPermission(item.permAny) : hasPermission(item.perm));

    const handleLogout = async () => {
        await logout();
        navigate("/login");
    };

    return (
        <aside className="hidden md:flex md:flex-col w-64 bg-slate-900 text-slate-300 sticky top-0 h-screen" data-testid="sidebar">
            <div className="px-3 py-3 border-b border-slate-800 flex items-center justify-center">
                <img src="/logo-emprenovus.png" alt="Emprenovus" className="h-14 w-auto object-contain" data-testid="sidebar-logo" />
            </div>
            <nav className="flex-1 px-3 py-4 space-y-1 overflow-y-auto">
                {visibleNav.map((item) => (
                    <NavLink key={item.to} to={item.to} data-testid={item.testid} className={linkClass}>
                        <item.icon className="w-5 h-5" />{item.label}
                    </NavLink>
                ))}
                {hasPermission("admin") && (
                    <NavLink to="/admin" data-testid="sidebar-nav-admin" className={linkClass}>
                        <Shield className="w-5 h-5" />Administración
                    </NavLink>
                )}
                {hasPermission("audit") && (
                    <NavLink to="/audit" data-testid="sidebar-nav-audit" className={linkClass}>
                        <ScrollText className="w-5 h-5" />Auditoría
                    </NavLink>
                )}
            </nav>
            <div className="border-t border-slate-800 p-4">
                <div className="flex items-center gap-3">
                    <div className="w-9 h-9 rounded-full bg-slate-700 flex items-center justify-center text-white text-sm font-medium">{user?.name?.[0]?.toUpperCase() || "U"}</div>
                    <div className="flex-1 min-w-0">
                        <div className="text-sm text-white font-medium truncate" data-testid="sidebar-user-name">{user?.name}</div>
                        <div className="text-xs text-slate-400 capitalize">{user?.role}</div>
                    </div>
                    <button onClick={handleLogout} className="text-slate-400 hover:text-white transition-colors" data-testid="logout-button"><LogOut className="w-4 h-4" /></button>
                </div>
            </div>
        </aside>
    );
}
